var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _path6, _path7, _circle4, _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCheckLaptop = function SvgCheckLaptop(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 363,
    height: 123,
    viewBox: "0 0 363 123",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 187.151,
    height: 104.096,
    transform: "matrix(1 0 -0.294979 0.955504 117.17 10.5355)",
    fill: "#F7EFE0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 187.151,
    height: 104.096,
    transform: "matrix(1 0 -0.294979 0.955504 117.17 10.5355)",
    fill: "url(#paint0_linear_check)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.788 7.47862L84.4744 119.476H279.521L310.313 11.1574C310.313 11.1574 313.377 0.121324 300.869 0.12115C298.422 0.121115 292.294 0.11067 283.643 0.0959265C248.066 0.0352897 169.831 -0.0980516 129.643 0.12115C127.046 0.393634 121.438 2.24661 119.788 7.47862ZM122.625 10.5132L91.7416 109.119H275.681L303.386 10.5123C293.018 9.94963 167.677 10.2787 122.625 10.5132Z",
    fill: "url(#paint1_linear_check)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.972 7.81651L82.6582 119.814H277.705L308.497 11.4953C308.497 11.4953 311.561 0.459215 299.053 0.45904C296.606 0.459006 290.478 0.448561 281.827 0.433817C246.25 0.37318 168.015 0.239839 127.827 0.45904C125.229 0.731525 119.622 2.5845 117.972 7.81651ZM120.811 10.8493L89.9272 109.455H273.867L301.572 10.8485C291.203 10.2858 165.863 10.6149 120.811 10.8493Z",
    fill: "url(#paint2_linear_check)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 118.448C0 115.951 2.02411 113.927 4.52097 113.927H274.109C277.88 113.927 279.993 118.272 277.665 121.239C276.808 122.331 275.497 122.969 274.109 122.969H4.52097C2.0241 122.969 0 120.945 0 118.448Z",
    fill: "url(#paint3_linear_check)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 118.448C0 115.951 2.02411 113.927 4.52097 113.927H274.109C277.88 113.927 279.993 118.272 277.665 121.239C276.808 122.331 275.497 122.969 274.109 122.969H4.52097C2.0241 122.969 0 120.945 0 118.448Z",
    fill: "url(#paint4_linear_check)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M237.986 118.448C237.986 115.951 240.01 113.927 242.507 113.927H274.826C278.463 113.927 280.611 118.002 278.556 121.003C277.713 122.233 276.318 122.969 274.826 122.969H242.507C240.01 122.969 237.986 120.945 237.986 118.448Z",
    fill: "url(#paint5_linear_check)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 124.597,
    cy: 81.4684,
    r: 3.19481,
    fill: "#F8E0A5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5394,
    cy: 50.3188,
    r: 5.59091,
    fill: "#F8E0A5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.0582,
    cy: 66.2928,
    r: 3.99351,
    fill: "#F8E0A5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9267 32.2476C87.2509 31.66 88.1114 31.7101 88.3653 32.3313L89.9641 36.243C90.0995 36.5745 90.4391 36.7753 90.7949 36.7343L95.2238 36.2235C95.9106 36.1442 96.3669 36.9159 95.9664 37.4795L92.9332 41.7488C92.8234 41.9034 92.7721 42.092 92.7886 42.2809L93.178 46.7359C93.2305 47.3376 92.622 47.7777 92.0671 47.5393L88.1014 45.8361C87.8699 45.7366 87.605 45.7523 87.3868 45.8783L83.1664 48.3161C82.5929 48.6474 81.8886 48.1768 81.9751 47.5202L82.6454 42.4328C82.6818 42.1567 82.5717 41.8816 82.355 41.7068L78.0373 38.224C77.4509 37.751 77.7853 36.8037 78.5387 36.8037H83.9409C84.2317 36.8037 84.4996 36.6455 84.6402 36.3909L86.9267 32.2476Z",
    fill: "#F8E0A5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7551 65.4465C50.9024 64.2349 52.3058 63.6334 53.2924 64.3591L58.2285 67.9906C58.6511 68.3015 59.1994 68.3864 59.6958 68.2179L65.531 66.2369C66.7169 65.8343 67.8884 66.8863 67.6098 68.1039L66.2203 74.1777C66.1158 74.6347 66.2184 75.1147 66.5009 75.4902L70.2548 80.4792C71.0067 81.4785 70.3691 82.9103 69.1222 83.0224L62.8364 83.5877C62.3935 83.6275 61.9876 83.8493 61.7161 84.1997L57.0164 90.2654C56.3215 91.1623 54.9343 91.0681 54.3642 90.0852L50.9151 84.1385C50.762 83.8745 50.5364 83.6597 50.2648 83.5193L43.4798 80.011C42.343 79.4232 42.3216 77.8106 43.4425 77.1975L49.0278 74.1426C49.4786 73.896 49.7824 73.4482 49.8443 72.9392L50.7551 65.4465Z",
    fill: "#F8E0A5"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.032,
    cy: 99.8397,
    r: 3.99351,
    fill: "#F8E0A5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.041 30.9741C181.706 30.9741 164.982 43.7114 160.71 59.4055C156.439 75.0996 166.229 87.8369 182.563 87.8369C198.898 87.8369 215.622 75.0996 219.894 59.4055C224.165 43.7114 214.375 30.9741 198.041 30.9741ZM178.963 71.6026L171.118 61.3957C170.265 60.2869 170.753 58.4957 172.209 57.3869C173.665 56.2781 175.529 56.2781 176.381 57.3869L182.704 65.5751L208.388 46.0143C209.844 44.9055 211.708 44.9055 212.56 46.0143C213.412 47.1231 212.925 48.9143 211.469 50.0231L183.135 71.6026C181.709 72.7114 179.815 72.7114 178.963 71.6026Z",
    fill: "#4F937E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_check",
    x1: 91.8659,
    y1: -18.6324,
    x2: 106.174,
    y2: 182.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_check",
    x1: 189.995,
    y1: -3.09002e-7,
    x2: 197.826,
    y2: 243.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94A6AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ACC0C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_check",
    x1: 196.082,
    y1: -23.6895,
    x2: 196.082,
    y2: 243.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#246893"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83C3E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_check",
    x1: -303.616,
    y1: 123.062,
    x2: 411.19,
    y2: 123.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86C4E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAD5EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_check",
    x1: -80.5908,
    y1: 123.13,
    x2: 92.1015,
    y2: 123.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_check",
    x1: 222.035,
    y1: 116.628,
    x2: 320.922,
    y2: 114.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADD1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3999C7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71.0201,
    height: 70.7178,
    fill: "white",
    transform: "matrix(1 0 -0.262633 0.964896 164.079 25.2924)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheckLaptop, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/checkLaptop.5316591e.svg";
export { ForwardRef as ReactComponent };